import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('serviceIntervalsButton');

    return {
        CONFIGURE_INTERVALS: t('configureIntervals')
    };
};

export default useTranslation;
